import React from "react";

export default function PrivacyPolicy() {
  return (
    <>
      <section id="privacy-policy" className="video-promo ptb-100">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-12">
              <div className="download-content">
                <h2>Privacy Policy</h2>
                <p>
                  At RemINR, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our app..
                </p>
                <h4>Information We Collect</h4>
                <p>We may collect personal information, such as your name, email address, phone number, and health-related information, when you use our app. We collect this information to provide you with personalized services and improve your experience.</p>
                <h4>How We Use Your Information</h4>
                <p>We use your information to provide you with the services you request, such as medication reminders and home INR monitoring. We may also use your information to communicate with you about our services and updates.</p>
                <h4>Data Security</h4>
                <p>We take data security seriously and use industry-standard measures to protect your information from unauthorized access, disclosure, or alteration. However, no method of transmission over the internet or electronic storage is 100% secure, so we cannot guarantee absolute security.</p>
                <h4>Third-Party Disclosure</h4>
                <p>We may disclose your information to third parties, such as service providers and partners, to provide you with our services. We do not sell your information to third parties.</p>
                <h4>Your Choices</h4>
                <p>You can choose not to provide us with certain information, but this may limit your ability to use certain features of our app. You can also opt-out of receiving promotional emails from us.</p>
                <h4>Changes to This Policy</h4>
                <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                <h4> Contact Us</h4>
                <p>
                  {" "}
                  If you have any questions about these terms and conditions,
                  please contact us at here.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
